import { api } from '../config';
import { fromJS } from 'immutable';
import store from '../store';
import cookie from 'react-cookie';
import { hashHistory } from 'react-router';
import * as actions from '../actions/auth';

export default function request(relativeUrl, rootKey, _method, body) {
  const method = _method || 'get';
  const url = api.root + relativeUrl;
  return fetch(url, {
    method,
    body: JSON.stringify(body),
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Token: ${store.getState().session.get('sessionToken')}`
    })
  }).catch((_err) => {
    throw new Error('No Internet Connectivity');
  }).then((res) => {
    if ( res.status === 204 ) {
      return Promise.resolve([ res, null ]);
    }
    if ( res.ok ) {
      return res.json().then((js) => [ res, js ]);
    }
    // TODO: move
    if ( res.status === 401 ) {
      const sessionToken = store.getState().session.get('sessionToken');
      if ( sessionToken ) {
        store.dispatch(actions.clearSession());
      }
    }
    return [ res, null ];
  }).then(([ res, js ]) => {
    if ( res.ok ) {
      return Promise.resolve(fromJS(rootKey ? js[rootKey] : js));
    }
    throw new Error(res.statusText);
  });
}



// WEBPACK FOOTER //
// ./src/lib/network-request.js